module.exports = new __parcel__URL__("vulcan--dataset-cover.1d6bfa66.jpg").toString();